/* eslint-disable no-template-curly-in-string */
import locale, { ArrayLocale, StringLocale } from "yup/lib/locale"
import { Message } from "yup/lib/types"

export const string: Required<StringLocale & { ascii?: Message, emailOrPhone?: Message, zxcvbn?: Message }> = {
  ...locale.string,

  ascii: '${path} contain invalid character',
  emailOrPhone: '${path} must be valid',
  zxcvbn: '${path} is not strong enough.',
};

export const array: Required<ArrayLocale & { unique?: Message }> = {
  ...locale.array,

  unique: '${path} already exists'
};

export default Object.assign(Object.create(null), {
  ...locale,
  string,
  array,
});
